export enum EventTypeEnum {
    EDUCATIONAL_CONFERENCE = 0,
    ENTERTAINMENT = 1,
    EVENT = 2,
    EXPO = 3,
    MEETINGS_AND_SEMINARS = 4,
    SOCIAL_GATHERING = 5,
    OTHERS = 6
}
